import { MOMENT_TIME } from '../../momenttime'
import { FORMAT } from '../core/format'
import { PAIPAN } from '../core/paipan'
import * as consts from '../base/consts'
import { UTILS } from '../../utils'

let COURSE_DATA_MANAGER = {
    /**
     * 根据服务器数据获取客户端对比列表数据
     * @param {服务器数据} listData 
     */
    getCourseListByList(listData, params) {
        let resultList = [];
        listData.forEach((data, index) => {
            // console.log('list-------', data)
            let tempData = this.getCouseFreeListByStatus(data.id, params);
            resultList.push(Object.assign(data, {
                cIndex: index,
                ratePrice: parseInt(data.rate_price/100),
                payPrice: data.pay && data.pay.price ? parseInt(data.pay.price/100) : 0,
                gotPaid: data.needBuy == 100,
                freeList: data.needBuy < 100 ? tempData.freeList : [],
                freePaidList: data.needBuy > 100 ? tempData.freePaidList : []
            }));
        });
        return resultList;
    },
    /**
     * 根据传入的用户vip状态获取状态数据
     * @param {课程id} cid 
     * @param {vip状态} params 
     */
    getCouseFreeListByStatus(cid, params) {
        console.log('getCouseFreeListByStatus----', cid, params);
        let freeList = [], freePaidList = [];
        switch(params.userVip) {
            case 0:
            case 10:
                switch(cid) {
                    case 1:
                        freeList = ['年会员免费订阅', '终身VIP免费解锁'];
                        break;
                    case 2:
                        freeList = ['年VIP可8折解锁', '终身VIP免费解锁'];
                        break;
                    case 3:
                        freeList = ['年VIP可8折解锁', '终身VIP可6折解锁'];
                        break;
                    default:
                        break;
                }
                break;
            case 20:
                switch(cid) {
                    case 1:
                        freePaidList = ['年会员已免费订阅'];
                        break;
                    case 2:
                        freeList = ['年VIP可8折解锁', '终身VIP免费解锁'];
                        break;
                    case 3:
                        freeList = ['年VIP可8折解锁', '终身VIP可6折解锁'];
                        break;
                    default:
                        break;
                }
                break;
            case 30:
                switch(cid) {
                    case 1:
                    case 2:
                        freePaidList = ['终身会员已免费解锁'];
                        break;
                    case 3:
                        freeList = ['终身VIP可6折解锁'];
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
        return {
            freeList: freeList,
            freePaidList: freePaidList
        };
    },
    /**
     * 获取courseInfo
     * @param {info} data 
     */
    getCourseInfoByData(info) {
        let tempData = UTILS.getDayHourMiSTimeByTime(info.limit_time);
        let ret = Object.assign({
            limitDay: tempData.day,
            limitTime: tempData.hms,
        }, info);
        return ret;
    },
    /**
     * 获取coursePayInfo
     * @param {pay} data 
     */
    getCoursePayInfoByData(pay) {
        let ret = Object.assign({
            payPrice: parseInt(pay.price/100),
            ratePrice: parseInt(pay.rate_price/100),
        }, pay);
        return ret;
    },
    /**
     * 获取付费的相关数据
     * @param {参数} params 
     */
    getCoursePayBtnDataByData(cid, vip) {
        cid = parseInt(cid);
        vip = parseInt(vip);
        let ret = {};
        switch(vip){
            case 0:
                switch(cid) {
                    case 1:
                        ret = Object.assign({
                            btnOrg: true, btnGreen: true, btnPrice: true,
                            btnTextList: [['开通年会员VIP', '赠送免费订阅'], ['马上购买']],
                            vipProductId: 'pay_40001',
                            vipDiscount: 1,
                        });
                        break;
                    case 2:
                        ret = Object.assign({
                            btnOrg: true, btnGreen: true, btnPrice: false,
                            btnTextList: [['免费解锁', '六爻+八字课程'], ['马上购买']],
                            vipProductId: 'pay_40020',
                            vipDiscount: 1,
                        });
                        break;
                    case 3:
                        ret = Object.assign({
                            btnOrg: true, btnGreen: true, btnPrice: true,
                            btnTextList: [['开通年会员VIP', '可8折购买课程'], ['马上购买']],
                            vipProductId: 'pay_40001',
                            vipDiscount: 1,
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 10:
                switch(cid) {
                    case 1:
                        ret = Object.assign({
                            btnOrg: true, btnGreen: true, btnPrice: true,
                            btnTextList: [['开通年会员VIP', '赠送免费订阅'], ['月会员VIP', '95折购买']],
                            vipProductId: 'pay_40001',
                            vipDiscount: 1,
                        });
                        break;
                    case 2:
                        ret = Object.assign({
                            btnOrg: true, btnGreen: true, btnPrice: false,
                            btnTextList: [['免费解锁', '六爻+八字课程'], ['月会员VIP', '95折购买']],
                            vipProductId: 'pay_40020',
                            vipDiscount: 1,
                        });
                        break;
                    case 3:
                        ret = Object.assign({
                            btnOrg: true, btnGreen: true, btnPrice: true,
                            btnTextList: [['开通年会员VIP', '可8折购买课程'], ['月会员VIP', '95折购买']],
                            vipProductId: 'pay_40001',
                            vipDiscount: 1,
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 20:
                switch(cid) {
                    case 2:
                        ret = Object.assign({
                            btnOrg: true, btnGreen: true, btnPrice: false,
                            btnTextList: [['免费解锁', '六爻+八字课程'], ['年会员VIP', '8折购买']],
                            vipProductId: 'pay_40020',
                            vipDiscount: 1,
                        });
                        break;
                    case 3:
                        ret = Object.assign({
                            btnOrg: true, btnGreen: true, btnPrice: false,
                            btnTextList: [['开通终身会员VIP', '可6折购买'], ['年会员VIP', '8折购买']],
                            vipProductId: 'pay_40002',
                            vipDiscount: 1,
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 30:
                switch(cid) {
                    case 3:
                        ret = Object.assign({
                            btnOrg: false, btnGreen: true, btnPrice: false,
                            btnTextList: [['终身会员VIP', '6折购买']],
                            vipDiscount: 1,
                        });
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        };
        console.log('getCoursePayBtnDataByData-------', cid, vip, ret);
        return ret;
    },
    /**
     * 获取courseTableList
     * @param {list} list 
     */
    getCourseTableListByList(list) {
        let retList = [];
        list.forEach(el => {
            let timeStr = MOMENT_TIME.getFormateTimeYMDByTimeStamp(el.f_create_time*1000);
            retList.push(Object.assign({
                timeStr: timeStr.replace(/\-/g, '.'),
            }, el));
        });
        return retList;
    },
    /**
     * 获取courseDetailInfo
     * @param {info} info 
     */
    getCourseDetailInfoByData(info) {
        let timeStr = MOMENT_TIME.getFormateTimeYMDByTimeStamp(info.f_create_time*1000);
        let ret = Object.assign({
            timeStr: timeStr.replace(/\-/g, '.'),
        }, info);
        return ret;
    },
    /**
     * 根据服务器数据获取客户端对比列表数据
     * @param {服务器数据} list 
     */
    getCourseRecordListByList(list) {
        let retList = [];
        list.forEach(el => {
            let time = el.f_study_time;
            let h = UTILS.getTimeStrByInt(parseInt(time/3600)), m = UTILS.getTimeStrByInt(parseInt((time-h*3600)/60)), s = UTILS.getTimeStrByInt(parseInt((time-h*3600-m*60)));
            retList.push(Object.assign({
                studyTimeStr: [h,m,s].join(':'),
            }, el));
        });
        return retList;
    }

}

export {
    COURSE_DATA_MANAGER
}
